<template>
  <div class="scoreSituation ub ub-pj">
    <div class="basInfo-table model-info bg-w">
      <div class="row">
        <div class="title">
          <span>基础信息得分</span>
          <span class="total-box ft12">合计 {{scoreObj.TotalScore || 0}}</span>
          <span class="col-r" style="margin-left: 10px;">(含基础分20分)</span>
        </div>
      </div>
      <div class="row">
        <div class="enter-box ub">
          <div class="item-enter tx-c"
               v-if="subjectType == 'company'"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="qyfzrbd"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">企业负责人绑定</div>
            <div class="title-box ft10">满分{{scoreObj.SuperintendentBindMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.SuperintendentBindScore}}</div>
          </div>
          <div class="item-enter tx-c"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="xmfzrbd"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">项目负责人绑定</div>
            <div class="title-box ft10">满分{{scoreObj.MangerBindRateMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.MangerBindRateScore}}</div>
          </div>
          <div class="item-enter tx-c"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="gyzjkh"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">共有资金开户</div>
            <div class="title-box ft10">满分{{scoreObj.CommonAccountOpenRateMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.CommonAccountOpenRateScore}}</div>
          </div>
          <div class="item-enter tx-c"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="gyzjkh"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">物业合同备案</div>
            <div class="title-box ft10">满分{{scoreObj.DataSupplementationRateMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.DataSupplementationRateScore}}</div>
          </div>
          <div class="item-enter tx-c"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="yzmyd"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">业主满意度</div>
            <div class="title-box ft10">满分{{scoreObj.SatisfactionRateMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.SatisfactionRateScore}}</div>
          </div>
          <div class="item-enter tx-c"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="xxgk"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">信息公开</div>
            <div class="title-box ft10">满分{{scoreObj.PublicRateMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.PublicRateScore}}</div>
          </div>
          <div class="item-enter tx-c"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="aqjc"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">安全检查</div>
            <div class="title-box ft10">满分{{scoreObj.SafetyCompletionRateMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.SafetyCompletionRateScore}}</div>
          </div>
          <div class="item-enter tx-c"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="pjfk"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">评价反馈</div>
            <div class="title-box ft10">满分{{scoreObj.EvaluationFeedbackRateMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.EvaluationFeedbackRateScore}}</div>
          </div>
          <div class="item-enter tx-c"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="tzfbxy"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">通知发布响应</div>
            <div class="title-box ft10">满分{{scoreObj.NotificationResponseRateMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.NotificationResponseRateScore}}</div>
          </div>
          <div class="item-enter tx-c"
               v-if="subjectType == 'company'"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="ndtjbb"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">年度统计报表</div>
            <div class="title-box ft10">满分{{scoreObj.SubmitTimesMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.SubmitTimesScore}}</div>
          </div>
          <div class="item-enter tx-c"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="zynlcp"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">专业能力测评</div>
            <div class="title-box ft10">满分{{scoreObj.ProfessionalCompletionRateMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.ProfessionalCompletionRateScore}}</div>
          </div>
          <div class="item-enter tx-c"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="EnterprisePersonManage"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">街道社区评价</div>
            <div class="title-box ft10">满分{{scoreObj.CommunityEvaluateMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.CommunityEvaluateScore}}</div>
          </div>
          <div class="item-enter tx-c"
               v-if="subjectType == 'company'"
               @click="goToBaseDetail">
            <div class="icon-box">
              <svg-icon icon-class="ndtjbb"
                        class="iconstyle"></svg-icon>
            </div>
            <div class="title-box ft-w">从业人员情况</div>
            <div class="title-box ft10">满分{{scoreObj.EmployeeMaxScore || 0}}分</div>
            <div class="title-box col-99 ft20 ft-w">{{scoreObj.EmployeeScore || 0}}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'scoreSituation',
  props: {
    subjectType: String,
    scoreObj: Object,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    goToBaseDetail() {
      this.$emit('goToBaseDetail');
    },
  },
};
</script>

<style lang="scss" scoped>
.scoreSituation {
  .model-info {
    background: #fff;
    .row {
      .total-box {
        box-sizing: border-box;
        padding: 5px 15px;
        margin-left: 10px;
        background: #1890ff;
        color: #fff;
        border-radius: 5px;
      }
      .scoring-rules {
        float: right;
        cursor: pointer;
      }
      .link {
        color: #1890ff;
        cursor: pointer;
      }
      .enter-box {
        box-sizing: border-box;
        padding: 10px;
        .item-enter {
          width: 110px;
          margin: 0 15px 15px 0;
          cursor: pointer;
          .icon-box {
            width: 42px;
            margin: 0 auto 6px;
            height: 42px;
            font-size: 36px;
            line-height: 40px;
            color: #1890ff;
            border: 1px solid #1890ff;
            border-radius: 10px;
          }
        }
      }
    }
  }
}
</style>
